import { OnWidgetDrilldown } from '../../types';
import { PieChartClickHandler } from './EChart';
import { ArdoqId, BarChartColorOptions, WidgetTypes } from '@ardoq/api-types';
import { BarChartRenderData, CategoricalDrilldownData } from '../renderTypes';
import { getWidgetDrilldownFilters } from '../getWidgetDrilldownFilters';
import { BarChartWidgetProps } from './BarChartWidget';
import { Locale } from '@ardoq/locale';
import {
  DEFAULT_BAR_CHART_PRIMARY_COLOR,
  DEFAULT_BAR_CHART_SECONDARY_COLOR,
} from '../../consts';
import { WidgetLinkedDashboardFilter } from '../types';

type GetBarChartPropsParam = {
  widgetRenderData: BarChartRenderData;
  widgetDrilldownData: CategoricalDrilldownData;
  onWidgetDrilldown?: OnWidgetDrilldown;
  colors: Record<string, string>;
  userLocale: Locale;
  activeLinkedDashboardFilters?: WidgetLinkedDashboardFilter[];
  dashboardId?: ArdoqId;
};
export const getBarChartProps = ({
  widgetRenderData,
  widgetDrilldownData,
  onWidgetDrilldown,
  activeLinkedDashboardFilters,
  dashboardId,
  ...props
}: GetBarChartPropsParam): BarChartWidgetProps & {
  viewType: WidgetTypes.BAR_CHART;
} => {
  const getClickHandler = onWidgetDrilldown
    ? (otherDataSegments: Array<{ name: string }>): PieChartClickHandler =>
        ({ data }) => {
          const filters = getWidgetDrilldownFilters({
            widgetRenderData: widgetRenderData.data,
            widgetDrilldownData,
            otherDataSegments,
            dataName: data.name,
            isOtherSegment: data.isOtherSegment,
            activeLinkedDashboardFilters,
          });
          onWidgetDrilldown({
            datasource: widgetDrilldownData.datasource,
            filters,
            widgetType: WidgetTypes.BAR_CHART,
            dashboardId,
          });
        }
    : undefined;
  return {
    ...props,
    ...widgetRenderData,
    numberOfBars: widgetRenderData.numberSlices,
    width: widgetRenderData.layout.w,
    numberFormatOptions: widgetRenderData.numberFormatOptions ?? undefined,
    isAbbreviated: widgetRenderData.isAbbreviated,
    getClickHandler,
    ...(widgetRenderData.colorSelection === BarChartColorOptions.COLOR_THEME
      ? {
          colorSelection: widgetRenderData.colorSelection,
          colors: props.colors,
        }
      : {
          colorSelection: BarChartColorOptions.SINGLE_COLOR,
          primaryColor:
            widgetRenderData.primaryColor ?? DEFAULT_BAR_CHART_PRIMARY_COLOR,
          secondaryColor:
            widgetRenderData.secondaryColor ??
            DEFAULT_BAR_CHART_SECONDARY_COLOR,
        }),
  };
};
